<template>
    <div :class="isCollapse?'navBoxer':'navBox'">
      <el-row class="tac">
        <el-col :span="4" class="scroll scrollbar">
          <el-menu
            :default-active="tabSt"
            class="el-menu-vertical-demo"
            background-color="#355577"
            text-color="#fff"
            active-text-color="#FD4C5C"
            :collapse="isCollapse"
          >
            <el-menu-item index="/index" @click="jumpMethod('/index')">
              <i class="el-icon-menu"></i>
              <span slot="title" class="text_size">首页</span>
            </el-menu-item>
            <el-submenu v-for="(item,index) in navList" :index="item.list[0].url" :key="index">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span class="text_size">{{item.menuName}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-for="(it,ind) in item.list" :key="ind" :index="it.url" class="text_size" @click="jumpMethod(it.url)">{{it.menuName}}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
</template>

<script>
export default {
  name: "Navtab",
  data(){
    return{
      navList: [],
      url: '',
    }
  },
  props:['tabSt','getFun','isCollapse'],
  watch: {
    tabSt: function(newVal,oldVal){
      this.getName();
    },
    getFun: function(newVal,oldVal){
      this.getName();
    }
  },
  created(){
    this.getName();
  },
  methods:{
    jumpMethod(url){
      var that=this;
      that.$router.push({
        path: url,
      })
    },
    getName(){
      var that=this;
      that.$http.axiosFun(that.$api.menus.all,{
      },function (res) {
        if (res.code=='0') {
          that.navList=res.data
        }else {
          // that.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .navBox{
    width: 240px;
    height: calc(100vh - 80px);
    .scroll{
      width: 240px;
      overflow-y: auto; 
      overflow-x: hidden;
    }
    .tac{
      // padding-top: 80px;
      height: 100%;
      background: #355577;
      /deep/
      .el-col-4,ul{
        height: 100%;
      }
      .el-menu{
        border: none;
      }
      /deep/
      .el-submenu__title{
        width: 240px;
      }
      .el-menu-item-group{
        margin-left: 15px;
      }
      .el-menu-item{
        width: 240px;
      }
      .text_size{
        font-size: 18px;
        width: 200px;
        color: #fff;
      }
    }
  }
  .navBoxer{
    // width: 240px;
    min-height: 100vh;
    .tac{
      padding-top: 80px;
      height: 100%;
      // background: #272849;
      /deep/
      .el-col-4,ul{
        height: 100%;
      }
      .el-menu{
        border: none;
      }
      /deep/
      // .el-submenu__title{
      //   width: 240px;
      // }
      .el-menu-item-group{
        margin-left: 15px;
      }
      // .el-menu-item{
      //   width: 240px;
      // }
      .text_size{
        font-size: 18px;
        width: 200px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navtab.vue